import Image from '@components/Image';
import styled from '@emotion/styled';
import useOnBannerClick from '@hooks/banner/useOnBannerClick';
import useAppCustom from '@hooks/useAppCustom';
import { BannerRow } from '@models/banner';

interface Props {
    banner: BannerRow;
}

function PopupBanner({ banner }:Props) {
    const {
        imageUrl,
    } = banner;
    const { popupType } = useAppCustom();
    const onBannerClick = useOnBannerClick();
    const handleClick = () => {
        onBannerClick(banner);
    };
    return (
        <Popup>
            {popupType === 'FULL' && (
                <Full src={imageUrl}
                    aria-label='full-banner'
                    onClick={handleClick}
                    alt='팝업 이미지' />
            )}
            {popupType === 'MEDIUM' && (
                <Medium src={imageUrl}
                    aria-label='medium-banner'
                    onClick={handleClick}
                    alt='팝업 배너 이미지' />
            )}
            {popupType === 'SHORT' && (
                <Short src={imageUrl}
                    aria-label='short-banner'
                    onClick={handleClick}
                    alt='팝업 배너 이미지' />
            )}
        </Popup>
    );
}

const Popup = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: white;
`;

const Short = styled(Image)`
    aspect-ratio: calc(360/336);
    width: 100%;
    overflow: hidden;
    object-fit: cover;
`;

const Medium = styled(Image)`
    width: 100%;
    aspect-ratio: calc(360/507);
    overflow: hidden;
    object-fit: cover;
`;

const Full = styled(Image)`
    width: 100%;
    object-fit: cover;
    height: calc(100vh - 60px);
`;

export default PopupBanner;
